export default "__VITE_ASSET__efb52a82__"